import React from 'react';
import { IconProps } from '.';
import Svg from '../Svg';
const SvgIconInfoSolid32 = ({ size = 32, color, ...props }: IconProps): JSX.Element => {
  return (
    <Svg width={size} height={size} fill='none' viewBox='0 0 32 32' color={color} {...props}>
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M16 27c6.075 0 11-4.925 11-11S22.075 5 16 5 5 9.925 5 16s4.925 11 11 11Zm.75-17v2h-1.5v-2h1.5Zm0 4v8h-1.5v-8h1.5Z'
        clipRule='evenodd'
      />
    </Svg>
  );
};
export default SvgIconInfoSolid32;
